var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"operation-report-show-body-task-progress"},_vm._l((_vm.workflowStatuesForDisplay),function(wsFD){return _c('operation-report-workflow-status',_vm._b({key:wsFD.id},'operation-report-workflow-status',wsFD,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }